import './sessionComplete.css';

// Reached by anyone who lands here without a valid share path — a bare visit to
// the domain, a truncated link, or a token URL that lost its `/s/` prefix. It
// reuses the thank-you screen's styling so the domain never renders as a blank page.
export default function InvalidLink() {
  return (
    <main className="psc-page">
      <div className="psc-glow" aria-hidden="true" />

      <section className="psc-card">
        <div className="psc-badge psc-badge--neutral" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 8v5" />
            <path d="M12 16.5v.01" />
          </svg>
        </div>

        <h1>This link isn&apos;t valid</h1>
        <p className="psc-lead">
          Presentation links look like <code>presenter.nuway.co/s/…</code> and expire after a while. Check that you opened the full link,
          or ask whoever sent it for a new one.
        </p>
      </section>

      <footer className="psc-footer">
        <span className="psc-mark">NUWAY</span>
        <span>AI presenter</span>
      </footer>
    </main>
  );
}
